
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/uploads",
      function () {
        return require("private-next-pages/my-account/uploads.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/uploads"])
      });
    }
  